<div class="tw-flex tw-flex-col tw-gap-4 tw-w-full">
  <div class="tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-2">
    <div>
      <h3 class="tw-text-lg tw-font-semibold tw-text-dt-text-headings tw-m-0">
        {{ "sourceExplorerAcrTestTitle" | i18n }}
      </h3>
      <p class="tw-m-0 tw-mt-1 tw-text-sm tw-text-dt-text-secondary">
        {{ "sourceExplorerAcrTestDescription" | i18n }}
      </p>
    </div>
    <div class="tw-flex tw-flex-wrap tw-gap-2">
      <button mat-stroked-button type="button" [disabled]="loading()" (click)="reload()">
        {{ "refresh" | i18n }}
      </button>
      <button
        mat-stroked-button
        type="button"
        [disabled]="!hasJson()"
        (click)="openUserJsonModal()"
      >
        {{ "sourceExplorerAcrTestViewJson" | i18n }}
      </button>
    </div>
  </div>

  @if (loading()) {
    <p class="tw-text-sm tw-text-dt-text-secondary tw-m-0">{{ "loading" | i18n }}…</p>
  }

  @if (errorMessage()) {
    <p class="tw-text-sm tw-text-dt-text-error tw-m-0">{{ errorMessage() }}</p>
  }

  @if (successMessage()) {
    <p class="tw-text-sm tw-text-dt-text-success tw-m-0">{{ successMessage() }}</p>
  }

  @if (!hasJson() && !loading()) {
    <p class="tw-text-sm tw-text-dt-text-secondary tw-m-0">
      {{ "sourceExplorerAcrTestLoadHint" | i18n }}
    </p>
  }

  @if (state(); as s) {
    <div
      class="tw-text-xs tw-text-dt-text-secondary tw-p-3 tw-bg-dt-surface-elevated tw-border tw-border-dt-border-secondary tw-rounded-lg"
    >
      <div>
        <strong>{{ "sourceExplorerAcrTestEligibility" | i18n }}:</strong>
        {{ formatEligibility(s.eligibility) }}
      </div>
      <div class="tw-mt-1">
        user: {{ s.user_id }} · {{ s.email }} · beta:
        {{ s.beta_access_features }}
      </div>
      <div class="tw-mt-1">
        toggle: {{ s.client_checks.can_show_toggle }} · renewal due:
        {{ s.client_checks.renewal_due }} · credits ≥
        {{ s.client_checks.credits_required }}
      </div>
    </div>
  }

  <form
    #acrTestForm="ngForm"
    class="tw-flex tw-flex-col tw-gap-4 tw-p-4 tw-border tw-border-dt-border-secondary tw-rounded-lg tw-bg-dt-surface-elevated tw-w-full tw-max-w-2xl"
    (ngSubmit)="$event.preventDefault(); save()"
  >
    <span class="tw-font-medium tw-text-dt-text-headings">{{
      "sourceExplorerAcrTestFormTitle" | i18n
    }}</span>

    <div
      class="tw-flex tw-flex-col tw-gap-2 tw-p-3 tw-bg-dt-surface-elevated tw-border tw-border-dt-border-secondary tw-rounded-lg"
    >
      <span class="tw-font-medium tw-text-dt-text-headings">{{
        "sourceExplorerAcrTestCreditsTitle" | i18n
      }}</span>
      <p class="tw-m-0 tw-text-xs tw-text-dt-text-secondary">
        {{ "sourceExplorerAcrTestCreditsHint" | i18n }}
      </p>
      @if (creditsLoading()) {
        <p class="tw-m-0 tw-text-sm tw-text-dt-text-secondary">{{ "loading" | i18n }}…</p>
      } @else if (currentCredits() !== null) {
        <p class="tw-m-0 tw-text-sm tw-text-dt-text-secondary">
          {{ "sourceExplorerAcrTestCreditsCurrent" | i18n }}:
          <strong>{{ currentCredits() }} CrS</strong>
          ({{ "sourceExplorerAcrTestCreditsRequired" | i18n }}: {{ creditsRequired }})
        </p>
      }
      <label class="tw-flex tw-flex-col tw-gap-1 tw-text-sm">
        <span class="tw-font-medium tw-text-dt-text-secondary">{{
          "sourceExplorerAcrTestCreditsTarget" | i18n
        }}</span>
        <input
          class="tw-border tw-border-dt-border-primary tw-rounded tw-px-3 tw-py-2 tw-bg-dt-surface-card"
          type="number"
          min="0"
          step="1"
          [(ngModel)]="form.target_credits"
          name="target_credits"
        />
      </label>
      <button
        mat-stroked-button
        type="button"
        [disabled]="saving() || creditsLoading()"
        (click)="applyCreditsOnly()"
      >
        {{ "sourceExplorerAcrTestCreditsApply" | i18n }}
      </button>
    </div>

    <div
      class="tw-flex tw-flex-col tw-gap-2 tw-p-3 tw-bg-dt-surface-elevated tw-border tw-border-dt-border-secondary tw-rounded-lg"
    >
      <span class="tw-font-medium tw-text-dt-text-headings">{{
        "sourceExplorerAcrTestCronTitle" | i18n
      }}</span>
      <p class="tw-m-0 tw-text-xs tw-text-dt-text-secondary">
        {{ "sourceExplorerAcrTestCronHint" | i18n }}
      </p>
      <div class="tw-flex tw-flex-wrap tw-gap-2">
        <button
          mat-stroked-button
          type="button"
          [disabled]="cronRunning() || saving()"
          (click)="runCronForCurrentUser()"
        >
          {{ "sourceExplorerAcrTestCronUser" | i18n }}
        </button>
        <button
          mat-stroked-button
          type="button"
          [disabled]="cronRunning() || saving()"
          (click)="runCronForAllEnrolled()"
        >
          {{ "sourceExplorerAcrTestCronAll" | i18n }}
        </button>
      </div>
    </div>

    <app-dropdown-select
      [label]="'sourceExplorerAcrTestTier' | i18n"
      [title]="'sourceExplorerAcrTestTier' | i18n"
      [options]="tierOptions"
      [selectedOption]="form.tier"
      (optionSelected)="onTierSelected($event)"
    />

    <app-dropdown-select
      [label]="'sourceExplorerAcrTestCycle' | i18n"
      [title]="'sourceExplorerAcrTestCycle' | i18n"
      [options]="cycleOptions"
      [selectedOption]="form.payment_cycle"
      (optionSelected)="onCycleSelected($event)"
    />

    <app-dropdown-select
      [label]="'sourceExplorerAcrTestProvider' | i18n"
      [title]="'sourceExplorerAcrTestProvider' | i18n"
      [options]="providerOptions"
      [selectedOption]="form.payment_provider"
      (optionSelected)="onProviderSelected($event)"
    />

    <label class="tw-flex tw-flex-col tw-gap-1 tw-text-sm">
      <span class="tw-font-medium tw-text-dt-text-secondary">{{
        "sourceExplorerAcrTestSubscriptionId" | i18n
      }}</span>
      <input
        class="tw-border tw-border-dt-border-primary tw-rounded tw-px-3 tw-py-2 tw-bg-dt-surface-card"
        type="text"
        [(ngModel)]="form.subscription_id"
        name="subscription_id"
      />
    </label>

    <div class="tw-flex tw-flex-col tw-gap-2">
      <mat-checkbox [checked]="form.active" (change)="onActiveChange($event.checked)" name="active">
        {{ "sourceExplorerAcrTestActive" | i18n }}
      </mat-checkbox>
      <mat-checkbox
        [checked]="form.auto_renew"
        (change)="onAutoRenewChange($event.checked)"
        name="auto_renew"
      >
        {{ "sourceExplorerAcrTestAutoRenew" | i18n }}
      </mat-checkbox>
      <mat-checkbox
        [checked]="form.clear_period_outcomes"
        (change)="onClearOutcomesChange($event.checked)"
        name="clear_outcomes"
      >
        {{ "sourceExplorerAcrTestClearOutcomes" | i18n }}
      </mat-checkbox>
    </div>

    @for (n of [datePickerNonce()]; track n) {
      <div class="tw-flex tw-flex-col tw-gap-3">
        <app-date-picker
          class="tw-w-full"
          [dateText]="form.date_renewal"
          [restrictDirection]="'both'"
          [selectedDateRange]="pickerDateRange"
          [isRequired]="false"
          [hasError]="false"
          [borderType]="'left'"
          [dateInputLabel]="'sourceExplorerAcrTestDateRenewal' | i18n"
          (changeDateEvent)="onDateChange($event, 'date_renewal')"
        />
        <app-date-picker
          class="tw-w-full"
          [dateText]="form.date_end"
          [restrictDirection]="'both'"
          [selectedDateRange]="pickerDateRange"
          [isRequired]="false"
          [hasError]="false"
          [borderType]="'right'"
          [dateInputLabel]="'sourceExplorerAcrTestDateEnd' | i18n"
          (changeDateEvent)="onDateChange($event, 'date_end')"
        />
        <app-date-picker
          class="tw-w-full"
          [dateText]="form.date_start"
          [restrictDirection]="'both'"
          [selectedDateRange]="pickerDateRange"
          [isRequired]="false"
          [hasError]="false"
          [borderType]="'left'"
          [dateInputLabel]="'sourceExplorerAcrTestDateStart' | i18n"
          (changeDateEvent)="onDateChange($event, 'date_start')"
        />
      </div>
    }

    <button mat-flat-button color="primary" type="button" [disabled]="saving()" (click)="save()">
      {{ "save" | i18n }}
    </button>
  </form>
</div>
